import moment from "moment";

export const office: Office = {
  todaySessions: 0,
  nextWorkdaySessions: 0,
  nextWorkdayDate: moment().format("YYYY-MM-DD"),
  nextWorkdayWorkTime: 0,
};
